export default {
  zh: {
    ra: "充值账户",
    r: "充值",
    eu: "请输入充值的用户ID",
    noExit: "该ID不存在",
    noNull: "不能为空",
    search: "查询",
    enterNation: "请选择国家",
    hot: "热门",
    all: "所有",
    policy: "阅读并同意App的服务条款、退货政策和隐私政策",
    otherId: "更换其他ID",
    eId: "请先选择需要充值的ID",
    help: "帮助",
    successful:"The operation was successful",
    eNation: "请选择国家",
    ePayMethods: "请选择支付方式",
    eRechargeGold: "请选择充值金额",
    ePolicy: "请选择同意条款",
    recharge:'Recharge',
  },
  
  en: {
    ra: "Recharge Account",
    r: "Recharge",
    eu: "Please Enter User ID",
    noExit: "This ID dosen’t exist.",
    noNull: "Cannot be empty",
    search: "Verify",
    enterNation: "Please select a country",
    hot: "Hot",
    all: "All",
    policy: "Read and agree to App's Terms of Service, Return Policy and Privacy Policy",
    otherId: "Recharge other ID",
    eId: "Please select the ID that needs to be recharged first",
    help: "Help",
    confirm: 'Confirm',
    eNation: "Please select a country",
    ePayMethods: "Please select mode of payment",
    eRechargeGold: "Please enter the recharge amount",
    ePolicy: "Please agree to the terms",
    recharge:'Recharge',
    checkText:"Check your bill",
    rechargeAmountText:"Recharge Amount",
    getRubiesText:"Get Rubies",
    getCoinsText:"Get Coins",
    deductRubiesText:"Deduct Rubies",
    deductCoinText:"Deduct Coins",
    successful:"The operation was successful",
    cancel: 'Cancel',
    total:" Total ",
  },

  ar: {
    ra: "حساب الشحن",
    r: "الشحن",
    eu: "أدخل ايدي",
    noExit: "هذا الايدي ليس موجودا",
    noNull: "لا يمكن أن تكون فارغة",
    search: "التحقيق",
    enterNation: "اختر دولة",
    hot: "شائع",
    all: "جميع",
    policy: "اقرأ ووافق على شروط الخدمة سياسة الإرجاع وسياسة الخاصة بشاتي الخصوصية",
    otherId: "تغيير الايدي",
    eId: "الرجاء إدخال معرف المستخدم",
    help: "ساعد",
    successful:"العملية كانت ناجحه",
    eNation: "رجاء قم بإختيار دوله",
    ePayMethods: "الرجاء تحديد طريقة الدفع",
    eRechargeGold: "الرجاء إدخال مبلغ إعادة الشحن",
    ePolicy: "الرجاء الموافقة على الشروط",
    recharge:'Recharge',
    checkText:"تحقق من فاتورتك",
    rechargeAmountText:"مبلغ الشحن",
    getRubiesText:"احصل على الياقوت",
    getCoinsText:"احصل على عملات معدنية",
    deductRubiesText:"خصم الياقوت",
    deductCoinText:"خصم العملات المعدنية",
    cancel: 'يلغي',
    total:" المجموع ",
    confirm: 'نعم',
  },

  tr: {
    ra: "şarj hesabı",
    r: "şarj etmek",
    eu: "Lütfen şarj kullanıcı kimliğini girin",
    noExit: "Kimlik mevcut değil",
    noNull: "Boş olamaz",
    search: "Sorgula",
    enterNation: "Lütfen bir ülke seçin",
    hot: "popüler",
    all: "Tümü",
    policy: "App'nin Hizmet Şartları, İade Politikası ve Gizlilik Politikasını okuyun ve kabul edin",
    otherId: "Başka bir kimliği değiştir",
    eId: "Lütfen önce şarj edilmesi gereken kimliği seçin",
    help: "yardım",
    cancel: 'İptal',
    successful:"İşlem Başarılı Oldu",
    recharge:'Recharge',
    eNation: "Lütfen bir ülke seçin",
    ePayMethods: "Lütfen ödeme şeklini seçin",
    eRechargeGold: "Lütfen şarj miktarını seçin",
    ePolicy: "Lütfen şartları kabul etmeyi seçin",
    checkText:"Faturanızı kontrol edin",
    rechargeAmountText:"Yükleme Miktarı",
    getRubiesText:"Yakutları Alın",
    getCoinsText:"Para Kazanın",
    deductRubiesText:"Yakutları Düş",
    deductCoinText:"Madeni Paraları",
    confirm: 'Yes',
    total:" Toplam ",
  },

  jp: {
    ra: "リチャージアカウント",
    r: "再充電",
    eu: "リチャージユーザーIDを入力してください",
    noExit: "IDが存在しません",
    noNull: "空にすることはできません",
    search: "お問い合わせ",
    enterNation: "国を選択してください",
    hot: "人気",
    all: "全て",
    policy: "App の利用規約、返品ポリシー、プライバシー ポリシーを読み、同意する",
    otherId: "別の ID を変更する",
    eId: "最初にリチャージする必要がある ID を選択してください",
    help: "ヘルプ",
    recharge:'Recharge',
    eNation: "国を選択してください",
    ePayMethods: "お支払い方法を選択してください",
    eRechargeGold: "チャージ金額を選択してください",
    ePolicy: "利用規約への同意を選択してください",
    total:" Total ",
  }
}


// WEBPACK FOOTER //
// src/component/Recharges/lang.js